/** 文件不能删，其他地方已经用到了 */
import { CASHBACK_BASE_URL } from '@/const';
import request from '@/utils/request'; // 推荐扩科

export function fetchExtendSubject(params) {
  if (params === void 0) {
    params = {};
  }

  return request({
    action: '/extend-subjects',
    prefix: '/api/fe',
    baseUrl: CASHBACK_BASE_URL,
    auth: true,
    method: 'GET',
    params: params,
    jumpAuth: false
  });
} // fe/user/extend-subjects